<!--
 * @Author: xiaokun
 * @Date: 2020-04-09 14:45:52
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-09 14:46:12
 * @Description: 学习任务
 -->
<template>
  <div class="learning-task">
    <!-- 学习任务 -->
    <list />
  </div>
</template>
<script>
import list from './list'
export default {
  name: 'LearningTask',
  components: {
    list
  }
}
</script>
<style lang="scss" scoped>
  .learning-task {
    width: 100%;
    height: 100%;
  }
</style>
